import { createContext, useState, useContext } from "react";

const AbonnementContext = createContext();

export const useAbonnement = () => useContext(AbonnementContext);

export function AbonnementProvider({ children }) {
  const [showModal, setShowModal] = useState(false);

  const showAbonnementModal = () => setShowModal(true);
  const hideAbonnementModal = () => setShowModal(false);

  return (
    <AbonnementContext.Provider
      value={{ showModal, showAbonnementModal, hideAbonnementModal }}
    >
      {children}

      {showModal && (
        <>
          <div className="modal-backdrop">
            <div className="modal-content centered">
              <h4>Votre abonnement a expiré</h4>
              <p>
                Veuillez renouveler votre abonnement pour continuer à utiliser
                l'application.
              </p>
              <a
                href="https://www.spyteam.fr/#tarifs"
                className="btn btn-primary"
              >
                Renouveler maintenant
              </a>
            </div>
          </div>
        </>
      )}
    </AbonnementContext.Provider>
  );
}
